import Unit from '@leverege/unit';
export default {
  ALL_VALUE_TYPES: ['string', 'int', 'number', 'percent', 'boolean', 'timestamp', 'geoJson', 'shape', 'ip', 'relationship', 'parentRelationship', 'enum', 'resourceEnum', ...Unit.getUnitTypes()]
};